import request from '@/api/base'
// 获取协管公司列表
const getEnterpriseList = (params) => {
  return request.post('/ipark-admin/pvlg/pageEnterpriseAssist', params)
}
// 根据id获取协管公司详情
const getCompanyById = (params) => {
  return request.post('/ipark-admin/pvlg/getEnterpriseAssistInfo', params)
}
// 获取协管公司拥有的权限
const getEnterpriseRoleList = (params) => {
  return request.post('/ipark-admin/pvlg/getEnterpriseRoleList', params)
}
// 添加协管公司
const addCoCompany = (params) => {
  return request.post('/ipark-admin/pvlg/addEnterpriseAssist', params)
}
// 添加协管公司
const updateCoCompany = (params) => {
  return request.post('/ipark-admin/pvlg/updateEnterpriseAssist', params)
}
const deleteCoCompany = (params) => {
  return request.post('/ipark-admin/pvlg/delEnterpriseAssist', params)
}
// 获取非协管公司的公司列表
const searchNormalCompany = (params) => {
  return request.post('/ipark-admin/enterprise/selectNotAssistPages', params)
}

export default {
  getEnterpriseList,
  getCompanyById,
  getEnterpriseRoleList,
  addCoCompany,
  updateCoCompany,
  searchNormalCompany,
  deleteCoCompany
}



// WEBPACK FOOTER //
// ./src/area-common/api/coManageService.js